// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3IGIZ","containerItemsCenter":"Skeleton_containerItemsCenter__Rahoe"};